import React, { useEffect, useState } from 'react';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import RightArrow from "../../../Components/SideBar/assets/icons/right-arrow.png";
import leftArrow from "../../../Components/SideBar/assets/icons/arrow-rigth.png";
import rightArrow from "../../../Components/SideBar/assets/icons/arrow-left.png";
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import OptionsPanel from 'Components/OptionsPanel/OptionsPanel';
import Button from 'Components/Button/Button';
import QuantityProducedPiecesPanel from './QuantityProducedPieces/QuantityProducedPieces';
import SuspendEmployeeHours from './SuspendEmployeeHours/SuspendEmployeeHours';
import DeleteConfirmation from './DeleteConfirmation/DeleteConfirmation';

const BalancingDay = (
    {
        onUpdateReloadProductionList,
        onUpdateDecreaseProductionPanelDay,
        productionDaysIdSelecteds,
        decreaseProductionPanelDay,
        mainPanel,
        showQuantityProducedPiecesPanelHelper,
        onUpdateShowQuantityProducedPiecesPanelHelper
    }) => {
    const [loadedBalancingEmployeeDayPanel, setLoadedBalancingEmployeeDayPanel] = useState(false);
    const [balancingDayList, setBalancingDayList] = useState(null)
    const [balancingInformationsLoader, setBalancingInformationsLoaded] = useState(null)
    const [balancingHourEmployeeList, setBalancingHourEmployeeList] = useState([]);
    const [hoursBalacingDay, setHoursBalacingDay] = useState(null);
    const [openBalacingInformation, setOpenBalacingInformation] = useState(false);
    const [hourSelected, setHourSelected] = useState(null)
    const [productionDayInformation, setProductionDayInformation] = useState(null)

    const handleClose = async () => {
        onUpdateDecreaseProductionPanelDay(!decreaseProductionPanelDay)
        onUpdateReloadProductionList(true)
    };

    const [dsOperation, setDsOperation] = useState(null)
    const [balanceDayEmployeesId, setBalanceDayEmployeesId] = useState([])
    const [allocatedMinutes, setAllocatedMinutes] = useState(null)
    const [quantityOperations, setQuantityOperations] = useState(null)
    const [totalMinutesPerDay, setTotalMinutesPerDay] = useState(null)
    const [balanceHourEmployeesIdLoading, setBalanceHourEmployeesIdLoading] = useState([])
    const [username, setUsername] = useState(null)
    const [dtUpdate, setDtUpdate] = useState(null)
    const [inserting, setInserting] = useState(null)
    const [updating, setUpdating] = useState(null)

    const [reloadBalanceEmployee, setReloadBalanceEmployee] = useState(null)
    const [reloadBalanceAllEmployeeHours, setReloadBalanceAllEmployeeHours] = useState(null)

    const [showQuantityProducedPiecesPanel, setShowQuantityProducedPiecesPanel] = useState(false)
    const [showDeleteConfirmationPanel, setShowDeleteConfirmationPanel] = useState(false)
    const [showSuspendEmployeeHoursPanel, setShowSuspendEmployeeHoursPanel] = useState(false)

    const attributeListEmployeeHours = [
        { name: "dsOperation", value: dsOperation, setter: setDsOperation, minGridWidth: '400px', maxGridWidth: '400px', cursor: 'text', whiteSpace: 'normal' },
        {
            name: "id",
            value: balanceDayEmployeesId,
            setter: callToSetEmployeeBalanceDayEmployee,
            allowsMultipleRecordsSelected: false,
            ignoreResetSelectRow: true,
            checks: [
                { field: 'allocatedMinutes', condition: 'NOT_NULL' },
                { field: 'quantityOperations', condition: 'NOT_NULL' }
            ],
            differentiatedCheckboxAlwaysArgument: true,
            disabledAttributoToValidate: 'suspensionDate'
        },
        { name: "allocatedMinutes", value: allocatedMinutes, setter: setAllocatedMinutes },
        { name: "quantityOperations", value: quantityOperations, setter: setQuantityOperations },
        { name: "totalMinutesPerDay", value: totalMinutesPerDay, setter: setTotalMinutesPerDay },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        getProductionDayInformations(productionDaysIdSelecteds)
        callToSetHoursBalacingDay(0).then((haveHours) => {
            if (hourSelected != 0 || !haveHours) {
                getBalanceEmployeeRecords()
            }
            getBalanceInformationsLeft()
        })
    }, [productionDaysIdSelecteds])

    useEffect(() => {
        if (reloadBalanceAllEmployeeHours) {
            setReloadBalanceAllEmployeeHours(false)
            callToSetHoursBalacingDay(0).then((haveHours) => {
                if (hourSelected != 0 || !haveHours) {
                    getBalanceEmployeeRecords()
                }
                getBalanceInformationsLeft()
            })
        }
    }, [reloadBalanceAllEmployeeHours])

    useEffect(() => {
        if (!hourSelected || hourSelected === 0) {
            return;
        }

        resetBalacing()
    }, [hourSelected])

    useEffect(() => {
        if (reloadBalanceEmployee) {
            setReloadBalanceEmployee(false)
            resetBalacing()
        }
    }, [reloadBalanceEmployee])

    async function resetBalacing() {
        getBalanceEmployeeRecords()
        getBalanceInformationsLeft()
    }

    const balacingDayPanelStyle = {
        flexDirection: 'column',
        '--modal-width-left': '30%',
        zIndex: '30'
    };

    const employeeBalacingDayPanelStyle = mainPanel
        ? {
            display: 'flex',
            flexDirection: 'column',
            zIndex: 30,
            '--modal-width-right': '70%',
        }
        : {
            display: 'flex',
            flexDirection: 'column',
            zIndex: 30,
            width: '100%',
        };

    function getPanelHoursBalancingDay(hoursBalacingDay) {
        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return (
                < LoadingIndicator loaded={(balancingHourEmployeeList && balancingHourEmployeeList.length > 0) && loadedBalancingEmployeeDayPanel} >
                    <PanelListDefault
                        onUpdateIdSelected={null}
                        idsSelected={[]}
                        data={[]}
                        attributeList={null}
                        isEmptyPanel={true}
                    />
                </LoadingIndicator>
            );
        }
        const options = hoursBalacingDay.map(hour => {
            return {
                label: hour.allocatedTime,
                setSequenceClicked: validateToSetHourSelected,
                sequence: hour.id,
                colorCode: hour.colorCode,
                component:
                    < LoadingIndicator loaded={(balancingHourEmployeeList && balancingHourEmployeeList.length > 0) && hourSelected && loadedBalancingEmployeeDayPanel} >
                        <PanelListDefault
                            onUpdateIdSelected={null}
                            idsSelected={[]}
                            data={balancingHourEmployeeList}
                            attributeList={attributeListEmployeeHours}
                            readOnlyModal={hour.enableButtonConfirmHours === 'N'}
                            loadingIndicatorIds={balanceHourEmployeesIdLoading}
                        />
                    </LoadingIndicator>
            };
        });

        return (
            <OptionsPanel
                zIndex={'20'}
                options={options}
                styleOptionSelected={
                    {
                        fontSize: '18px'
                    }
                }
            />

        );
    }

    function validateToSetHourSelected(hour) {
        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            alert('Aguarde o carregamento total das horas selecionadas')
            return false
        } else {
            setHourSelected(hour)
            return true
        }
    }

    const mainBalacingInformation = {
        height: 'calc(100% - 56px)',
        transition: 'width 2s ease-in-out'
    };

    const styleQuantityProcedPiecesButton = {
        width: '85px',
        float: 'right',
        color: (!enableQuantityPiecesButton()) ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const stylePrintButton = {
        width: '110px',
        float: 'right',
        color: (!enablePrintButton()) ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const styleDeleteConfirmationButton = {
        width: '120px',
        float: 'right',
        color: (!enableDeleteButton())
            ? 'rgba(32, 27, 35, 0.53)' : 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const styleSuspendEmployeeHoursButton = {
        width: '145px',
        float: 'right',
        color: (!enableSuspendButton()) ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const styleGenerateBalanceButton = {
        width: '120px',
        float: 'right',
        color: (!enableNewRecordBalance()) ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function getConfirmQuantityPiecesButton() {
        return (
            <Button
                clickMethod={() => { setShowQuantityProducedPiecesPanel(true) }}
                buttonName={'Quantidade de peças'}
                style={styleQuantityProcedPiecesButton}
                disabled={!enableQuantityPiecesButton()}
                readOnly={!enableQuantityPiecesButton()}
            />
        )
    }

    function getPrintButton() {
        return (
            <Button
                clickMethod={() => { balancePrint(productionDaysIdSelecteds) }}
                buttonName={'Imprimir balanceamento'}
                style={stylePrintButton}
                disabled={!enablePrintButton()}
                readOnly={!enablePrintButton()}
            />
        )
    }

    async function balancePrint(productionDaysIdSelecteds) {
        try {
            const base64PDF = await ExecuteAxios.api('get', `/balance-employee/reports/`,
                {
                    params: {
                        productionDayId: productionDaysIdSelecteds[0],
                        balanceHoursId: hourSelected
                    },
                    responseType: 'blob'
                });
            const blob = new Blob([base64PDF], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            window.open(url, '_blank');
        } catch (error) {
            console.log(error)
        }
    }

    function getDeleteConfirmationButton() {
        return (
            <Button
                clickMethod={() => { setShowDeleteConfirmationPanel(true) }}
                buttonName={'Excluir balanceamento'}
                style={styleDeleteConfirmationButton}
                disabled={!enableDeleteButton()}
                readOnly={!enableDeleteButton()}
            />
        )
    }

    function getConfirmSuspendEmployeeHours() {
        return (
            <Button
                clickMethod={() => { setShowSuspendEmployeeHoursPanel(true) }}
                buttonName={'Suspender/Desfazer hora colaborador'}
                style={styleSuspendEmployeeHoursButton}
                disabled={!enableSuspendButton()}
                readOnly={!enableSuspendButton()}
            />
        )
    }

    function getGenerateBalancing() {
        if (!enableNewRecordBalance()) {
            return null
        }
        return (
            <Button
                clickMethod={async () => {
                    await postBalanceDay(true)
                }}
                buttonName={'Gerar balanceamento'}
                style={styleGenerateBalanceButton}
                readOnly={!enableNewRecordBalance()}
                disabled={!enableNewRecordBalance()}
            />
        )
    }

    function getButtonsLeft() {
        return (
            <>
                {mainPanel ? getPrintButton() : null}
                {mainPanel ? getConfirmQuantityPiecesButton() : null}
                {mainPanel ? getConfirmSuspendEmployeeHours() : null}
                {mainPanel ? getGenerateBalancing() : null}
                {mainPanel ? getDeleteConfirmationButton() : null}
            </>
        )
    }

    function enableNewRecordBalance() {
        if (!loadedBalancingEmployeeDayPanel) {
            return false
        }

        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (hoursBalacingDay && hoursBalacingDay.length > 0) {
            return false
        }

        if (balancingDayList && balancingDayList.length > 1) {
            return false
        }

        return true
    }

    function enableNewRecordEmployeeHours() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (hoursBalacingDay && hoursBalacingDay.some(hour => hour.id === hourSelected && hour.enableButtonConfirmHours === 'N')) {
            return false
        }

        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            return false
        }

        return true
    }

    function enableEditRecordEmployeeHours() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (hoursBalacingDay && hoursBalacingDay.some(hour => hour.id === hourSelected && hour.enableButtonConfirmHours === 'S')) {
            return false
        }

        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            return false
        }

        return true
    }

    function enableSuspendButton() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (hoursBalacingDay && hoursBalacingDay.some(hour => hour.id === hourSelected && hour.enableButtonConfirmHours === 'S')) {
            return false
        }

        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            return false
        }

        if (showSuspendEmployeeHoursPanel) {
            return false;
        }

        return true
    }

    function enablePrintButton() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            return false
        }

        if (showQuantityProducedPiecesPanel) {
            return false
        }

        return true
    }

    function enableQuantityPiecesButton() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (balanceHourEmployeesIdLoading && balanceHourEmployeesIdLoading.length > 0) {
            return false
        }

        if (showQuantityProducedPiecesPanel) {
            return false
        }

        return true
    }

    function canEditRecordsQuantityPieces() {
        if (hoursBalacingDay && hoursBalacingDay.some(hour => hour.id === hourSelected && hour.enableButtonConfirmHours === 'S')) {
            return false
        } else {
            return true
        }
    }

    function enableDeleteButton() {
        if (!productionDaysIdSelecteds || productionDaysIdSelecteds.length !== 1) {
            return false
        }

        if (!hoursBalacingDay || hoursBalacingDay.length === 0) {
            return false
        }

        if (!balancingDayList || balancingDayList.length <= 1) {
            return false
        }

        if (showDeleteConfirmationPanel) {
            return false
        }

        return true
    }

    async function callToSetHoursBalacingDay(hourSelected) {
        const parameters = { productionDayId: productionDaysIdSelecteds[0] }
        const hoursBalacingDay = await ExecuteAxios.api('get', `/balance-hours/get-list-of-hours-allocated-by-production-day/`, { params: parameters });

        let hourSelectedHelper = hourSelected;
        if (hoursBalacingDay && hoursBalacingDay.length > 0) {
            if (!hourSelectedHelper || hourSelectedHelper === 0) {
                const minHour = hoursBalacingDay.reduce((prev, current) => {
                    return prev.allocatedTime < current.allocatedTime ? prev : current;
                });

                setHourSelected(minHour.id)
                hourSelectedHelper = minHour.id
            }
            setHoursBalacingDay(hoursBalacingDay);
            return true
        } else {
            setBalancingHourEmployeeList([])
            setHourSelected(0);
            setHoursBalacingDay([]);
            return false
        }
    }

    async function getBalanceInformationsLeft() {
        try {
            setBalancingInformationsLoaded(false)
            const parameters = {
                productionDayId: productionDaysIdSelecteds[0],
                balanceHoursId: hourSelected
            }
            const balacing = await ExecuteAxios.api('get', `/balance-day/get-balance-day-grid/`, { params: parameters })
            setBalancingDayList(balacing)
        } finally {
            setBalancingInformationsLoaded(true)
        }
    }

    async function getBalanceEmployeeRecords(reloadAllPanel = true) {
        if (reloadAllPanel) {
            setLoadedBalancingEmployeeDayPanel(false);
        }

        const parameters = {
            params: {
                productionDayId: productionDaysIdSelecteds[0],
                selectedHourId: hourSelected,
                isBalancing: mainPanel ? 'S' : 'N'
            },
        };

        try {
            const BalanceHour = await ExecuteAxios.api('get', `/balance-employee/get-balance-employee-grid/`, parameters);

            setBalancingHourEmployeeList(BalanceHour);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        } finally {
            setLoadedBalancingEmployeeDayPanel(true);
        }
    }

    async function getProductionDayInformations(productionDaysIdSelecteds) {
        const parameters = {
            productionDayId: productionDaysIdSelecteds[0]
        }
        const informations = await ExecuteAxios.api('get', `/balance-hours/get-product-day-information/`, { params: parameters });
        setProductionDayInformation(informations);
    }

    async function callToSetEmployeeBalanceDayEmployee(value) {
        const idHourToValidate = value[0];
        setBalanceHourEmployeesIdLoading(prevState => [...prevState, idHourToValidate]);
        const response = await ExecuteAxios.api('put', `/balance-employee/`, {
            id: idHourToValidate
        });

        if (response) {
            const reloadAllPanel = false;
            await getBalanceEmployeeRecords(reloadAllPanel);
            setBalanceHourEmployeesIdLoading(prevState =>
                prevState.filter(id => id !== idHourToValidate)
            );
        }

        return response;
    }

    async function postBalanceDay() {
        try {
            setLoadedBalancingEmployeeDayPanel(false)
            const response = await ExecuteAxios.api('post', `/balance-hours/`, { productionDayId: productionDaysIdSelecteds[0] });

            if (response) {
                onUpdateReloadProductionList(true)
                setReloadBalanceAllEmployeeHours(true)
            }

            return response
        } finally {
            setLoadedBalancingEmployeeDayPanel(true)
        }
    }

    async function putBalanceDayEmployee() {
        try {
            setLoadedBalancingEmployeeDayPanel(false)
            const response = await ExecuteAxios.api('put', `/balance-employee/undo-conformation-date/`, {
                productionDayId: productionDaysIdSelecteds[0]
            });

            if (response) {
                onUpdateReloadProductionList(true)
                setReloadBalanceAllEmployeeHours(true)
            }

            return response;
        } finally {
            setLoadedBalancingEmployeeDayPanel(true)
        }
    }

    async function postBalanceDayEmployee() {
        try {
            setLoadedBalancingEmployeeDayPanel(false)
            const response = await ExecuteAxios.api('put', `/balance-employee/update-balance-conformation-date/`, {
                productionDayId: productionDaysIdSelecteds[0]
            });

            if (response) {
                onUpdateReloadProductionList(true)
                setReloadBalanceAllEmployeeHours(true)
            }

            return response;
        } finally {
            setLoadedBalancingEmployeeDayPanel(true)
        }
    }


    function getPanelDescription(productionDayInformation) {
        const isoDate = productionDayInformation?.productionDay;

        let formattedDate = '';
        if (isoDate) {
            const date = new Date(isoDate);
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            formattedDate = `${day}/${month}/${year}`;
        }

        return ' - ' + formattedDate + ' - ' + productionDayInformation?.productCode;
    }


    if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1 && decreaseProductionPanelDay) {
        return (
            <>  {mainPanel ?
                <Panel
                    style={balacingDayPanelStyle}
                    titlePage={'Informações das operações'}
                    canViewCRUD={true}
                    viewOnlyOneRecordCRUD={true}
                    className={!openBalacingInformation ? 'main-modal not-visible' : 'main-modal two left'}
                >
                    < LoadingIndicator loaded={balancingInformationsLoader} >
                        <div style={mainBalacingInformation}>
                            <PanelListDefault
                                onUpdateIdSelected={null}
                                idsSelected={productionDaysIdSelecteds}
                                data={balancingDayList}
                                attributeList={null}
                            />
                        </div>
                    </LoadingIndicator >
                </Panel> : null
            }
                <Panel
                    style={employeeBalacingDayPanelStyle}
                    titlePage={mainPanel ? 'Balanceamento hora' + getPanelDescription(productionDayInformation) : null}
                    updating={updating}
                    setUpdating={setUpdating}
                    canEdit={true}
                    enableEdit={mainPanel ? enableEditRecordEmployeeHours() : null}
                    putFunction={putBalanceDayEmployee}
                    updateNameButton='Desfazer confirmação'
                    saveNameButton='Confirmar'
                    inserting={inserting}
                    setInserting={setInserting}
                    enableNewRecord={mainPanel ? enableNewRecordEmployeeHours() : null}
                    postFunction={postBalanceDayEmployee}
                    newRecordNameButton='Confirmar horários'
                    insertNameButton='Confirmar'
                    canNewRecord={true}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={null}
                    viewOnlyOneRecordCRUD={true}
                    resetVariables={null}
                    className={mainPanel ? (!openBalacingInformation ? 'main-modal' : 'main-modal two right') : ''}
                    componentLeftButtons={getButtonsLeft()}
                    withoutCrud={!mainPanel}
                    componentRightButtons={
                        mainPanel ? <button
                            style={{
                                backgroundImage: `url(${RightArrow})`,
                                backgroundSize: '30px 30px',
                                width: '35px',
                                height: '35px',
                                backgroundRepeat: 'no-repeat',
                                backgroundColor: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                alignItems: 'center'
                            }}
                            onClick={handleClose}
                        /> : null
                    }
                    componentLeftFilter={mainPanel ?
                        <button
                            style={{
                                backgroundImage: openBalacingInformation ? `url(${rightArrow})` : `url(${leftArrow})`,
                                backgroundSize: '30px 30px',
                                width: '35px',
                                height: '30px',
                                backgroundRepeat: 'no-repeat',
                                backgroundColor: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                alignItems: 'center'
                            }}
                            onClick={() => {
                                setOpenBalacingInformation(!openBalacingInformation)
                            }} /> : null
                    }
                >
                    <QuantityProducedPiecesPanel
                        productionDaysIdSelecteds={productionDaysIdSelecteds}
                        onUpdateShowQuantityProducedPiecesPanel={onUpdateShowQuantityProducedPiecesPanelHelper || setShowQuantityProducedPiecesPanel}
                        onUpdateReloadBalanceEmployee={setReloadBalanceEmployee}
                        showQuantityProducedPiecesPanel={showQuantityProducedPiecesPanel || showQuantityProducedPiecesPanelHelper}
                        canEditRecordsQuantityPieces={!mainPanel || canEditRecordsQuantityPieces()}
                        onUpdateReloadProductionList={onUpdateReloadProductionList}
                    />
                    <SuspendEmployeeHours
                        productionDaysIdSelecteds={productionDaysIdSelecteds}
                        onUpdateShowSuspendHoursPanel={setShowSuspendEmployeeHoursPanel}
                        showSuspendEmployeeHoursPanel={showSuspendEmployeeHoursPanel}
                        onUpdateReloadBalanceAllEmployeeHours={setReloadBalanceAllEmployeeHours}
                        onUpdateReloadProductionList={onUpdateReloadProductionList}
                    />
                    <DeleteConfirmation
                        productionDaysIdSelecteds={productionDaysIdSelecteds}
                        onUpdateShowDeleteConfirmationPanel={setShowDeleteConfirmationPanel}
                        onUpdateReloadBalanceAllEmployeeHours={setReloadBalanceAllEmployeeHours}
                        showDeleteConfirmationPanel={showDeleteConfirmationPanel}
                        onUpdateReloadProductionList={onUpdateReloadProductionList}
                    />
                    <div style={{ height: !mainPanel ? '100%' : 'calc(100% - 56px)' }}>
                        {getPanelHoursBalancingDay(hoursBalacingDay)}
                    </div>
                </Panel >
            </>
        )
    } else {
        return null
    }
};

export default BalancingDay;
